var map = {
	"./Asset.png": 828,
	"./amor.png": 9051,
	"./amorArrow.png": 4872,
	"./anchor.png": 6421,
	"./carriage.png": 6912,
	"./crown.png": 4937,
	"./doubleHeart.png": 9557,
	"./doubleHeartArrow.png": 9702,
	"./doubleRings.png": 5380,
	"./heart.png": 2296,
	"./heartArrow.png": 4021,
	"./heartCastle.png": 4236,
	"./infinity.png": 6778,
	"./pigeon.png": 1576
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4097;